import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import './assets/css/main.css';

Vue.config.productionTip = false;

Vue.prototype.$feedback = Vue.observable({
  visible: false
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
